"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuComponent = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const mithril_component_1 = require("../mithril.component");
const theme_1 = require("../theme");
const menu_item_1 = require("./menu.item");
const menu_style_1 = require("./menu.style");
(0, theme_1.addStyles)(menu_style_1.Style);
class MenuComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(attrs) {
        super();
        this.closeTask = new core_shared_1.IkeDelayedTask(this.remove, 200);
        this.isOpen = false;
        this.isClosing = false;
        this.selectedItemIndex = 0;
        this.className = attrs.className;
        this.itemsFunc = attrs.items;
        this.openFunc = attrs.open;
        this.eventContext = services_1.Services.Input.getContext();
    }
    onCreate() {
        if (typeof this.openFunc === 'function') {
            this.reaction(() => this.openFunc(), this.toggle, { fireImmediately: true });
        }
    }
    get nodes() {
        if (!this.isOpen) {
            return null;
        }
        let className = `${menu_style_1.CSS.menu} ${this.isOpen ? menu_style_1.CSS.isOpen : menu_style_1.CSS.isClosed}`;
        if (this.className != null) {
            className += ` ${this.className}`;
        }
        if (this.isClosing) {
            className += ` ${menu_style_1.CSS.isClosing}`;
        }
        const items = this.items;
        if (items == null || items.length === 0) {
            return null;
        }
        const children = [];
        for (let i = 0; i < items.length; i++) {
            const menuItem = items[i];
            if (menuItem.component) {
                children.push(menuItem.view);
            }
            else {
                const selected = i === this.selectedItemIndex;
                children.push(menu_item_1.MenuItemWrapperComponent.view(this, menuItem, selected));
            }
            if (menuItem.divider) {
                children.push((0, mithril_1.m)('div', { className: menu_style_1.CSS.divider }));
            }
        }
        return (0, mithril_1.m)('div', {
            className,
            oncreate: (node) => services_1.Services.FocusAway.from(node.dom, this.hide),
        }, children);
    }
    get items() {
        const menuItems = this.itemsFunc();
        if (menuItems == null) {
            return [];
        }
        return menuItems;
    }
    get hasUsableItems() {
        const items = this.items;
        for (const item of items) {
            if (item.visible !== false && !item.disabled) {
                return true;
            }
        }
        return false;
    }
    remove() {
        this.isOpen = false;
        this.isClosing = false;
    }
    hide() {
        this.toggle(false);
    }
    show() {
        this.toggle(true);
    }
    toggle(shouldOpen) {
        if (shouldOpen) {
            this.isOpen = true;
            this.isClosing = false;
            this.closeTask.cancel();
            this.bindKeyboardEvents();
            const selectedIndex = this.items.findIndex((i) => i.selected);
            this.selectedItemIndex = Math.max(0, selectedIndex);
        }
        else {
            this.isClosing = true;
            if (this.closeTask.isActive) {
                return;
            }
            this.closeTask.delay();
            this.eventContext.destroy();
        }
    }
    selectItem(item) {
        const selectedIndex = this.items.findIndex((i) => i === item);
        this.selectedItemIndex = Math.max(0, selectedIndex);
    }
    selectCurrentItem(e) {
        e.event.stopPropagation();
        e.event.preventDefault();
        const menuItem = this.getSelectedItem();
        if (menuItem != null && menuItem.action != null) {
            menuItem.action();
        }
        this.hide();
    }
    getSelectedItem() {
        return this.items[this.selectedItemIndex];
    }
    selectItemIndex(delta) {
        const items = this.items;
        let index = this.wrap(this.selectedItemIndex + delta, items.length);
        while (items[index].visible === false || items[index].disabled) {
            if (index === this.selectedItemIndex) {
                // No other selectable items. Stop
                return;
            }
            index = this.wrap(index + delta, items.length);
        }
        this.selectedItemIndex = index;
    }
    wrap(index, count) {
        return ((index % count) + count) % count;
    }
    bindKeyboardEvents() {
        this.eventContext.on(this.eventContext.Code.ArrowUp, () => this.selectItemIndex(-1));
        this.eventContext.on(this.eventContext.Code.ArrowDown, () => this.selectItemIndex(1));
        this.eventContext.on(this.eventContext.Code.Enter, this.selectCurrentItem);
        this.eventContext.on(this.eventContext.Code.Escape, this.hide);
    }
    onRemove() {
        super.onRemove();
        this.eventContext.destroy();
    }
}
exports.MenuComponent = MenuComponent;
tslib_1.__decorate([
    mobx_1.observable
], MenuComponent.prototype, "isOpen", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MenuComponent.prototype, "isClosing", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MenuComponent.prototype, "selectedItemIndex", void 0);
tslib_1.__decorate([
    mobx_1.computed
], MenuComponent.prototype, "items", null);
tslib_1.__decorate([
    mobx_1.computed
], MenuComponent.prototype, "hasUsableItems", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MenuComponent.prototype, "remove", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MenuComponent.prototype, "hide", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MenuComponent.prototype, "show", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MenuComponent.prototype, "toggle", null);
tslib_1.__decorate([
    mobx_1.action
], MenuComponent.prototype, "selectItem", null);
tslib_1.__decorate([
    mobx_1.action.bound
], MenuComponent.prototype, "selectCurrentItem", null);
tslib_1.__decorate([
    mobx_1.action
], MenuComponent.prototype, "selectItemIndex", null);
//# sourceMappingURL=menu.js.map